var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hideBar)?_c('div',{staticClass:"nav-iconfont iconfont",on:{"click":_vm.goBack}},[_vm._v("  ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }